var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_254_372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7034 7.65753C13.7034 7.08003 13.6597 6.66003 13.5549 6.22253H6.99219V8.82128H10.8459C10.7673 9.46878 10.3478 10.44 9.41278 11.0963L9.40404 11.1838L11.4751 12.7938L11.6149 12.8113C12.9432 11.5863 13.7034 9.78378 13.7034 7.65753Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98936 14.5001C8.8769 14.5001 10.4586 13.8788 11.6208 12.8026L9.41869 11.0876C8.82447 11.4988 8.03799 11.7876 6.9981 11.7876C5.14552 11.7876 3.58131 10.5626 3.02204 8.88257L2.94339 8.89132L0.776216 10.5626L0.75 10.6413C1.89476 12.9251 4.25418 14.5001 6.98936 14.5001Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.01482 8.8826C2.86626 8.4451 2.77888 7.98135 2.77888 7.5001C2.77888 7.01885 2.86626 6.5551 3.00608 6.1176V6.02135L0.821429 4.32385L0.75152 4.35885C0.270897 5.30385 0 6.37135 0 7.5001C0 8.62885 0.270897 9.69635 0.742781 10.6413L3.01482 8.8826Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99029 3.20375C8.30108 3.20375 9.19242 3.7725 9.69052 4.245L11.6654 2.32C10.4508 1.19125 8.87783 0.5 6.99029 0.5C4.25511 0.5 1.89568 2.075 0.742188 4.35875L3.00549 6.1175C3.57349 4.42875 5.1377 3.20375 6.99029 3.20375Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_254_372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.f74a061aab1af6127556e241f95fdabd.svg";
export { ForwardRef as ReactComponent };